import { makeStyles } from '@material-ui/core/styles';

export const Styles = makeStyles((theme) => ({
    wrapper: {
        width: '100%',
        padding: '1.5em',
        margin: '0.5em 0',
        borderRadius: 0,
        boxSizing: 'border-box',
        boxShadow: '1px 3px 7px #dddddd'
    },
    label: {
        color: '#326d9a',
        marginRight: '0.5em',
        fontWeight:500
    }
}));
